import { Box, TextField } from "@mui/material"
import { useState } from "react"
import { DatePickerWrapper } from "./DatePickerWrapper"
import { DatePickerModal } from "./styled"
import { MomentProvider } from "./providers"
import { useTranslation } from "react-i18next"
import { I18N_NAMESPACE } from "./i18n"


interface Props {
    label: string
    value?: number
    onChange: (value?: number) => void
    withTime?: boolean
    range?: {
        min?: Date | number
        max?: Date | number
    }
}

export function DatePicker(props: Props){
    const {
        label,
        value,
        onChange,
        withTime,
        range
    } = props
    const [defaultValue] = useState(new Date())
    const [isOpen, setOpen] = useState(false)
   

    const currentDate = value ? new Date(value) : defaultValue
    
    const { t } = useTranslation(I18N_NAMESPACE)

    return (
        <MomentProvider>
            <Box sx={{width: '100%'}}>
                <DatePickerModal 
                    open={isOpen} 
                    onClose={() => {
                        setOpen(false)
                    }}
                >
                    <DatePickerWrapper 
                        currentDate={currentDate}
                        closeModal={() => {
                            setOpen(false)
                        }}
                        onChange={(timestamp?: number) => {
                            if(!timestamp) return
                            onChange(timestamp)
                        }}
                        withTime={withTime}
                        range={range}
                    />
                </DatePickerModal>
                <TextField
                    fullWidth
                    label={label}
                    slotProps={{
                        htmlInput: {
                            readOnly: true
                        }
                    }}
                    sx={{
                        fontFamily: 'Rubik',
                        '& > .MuiInputBase-root > fieldset': {
                            borderRadius: '8px',
                        }
                    }}
                    value={new Date(currentDate).toLocaleString()}
                    aria-disabled={true}
                    onClick={() => setOpen(!isOpen)}
                />
            </Box>
        </MomentProvider>
    )
}